export const ADD_VA_BUTTON =
    'inline-flex items-center gap-1.5 bg-white text-gray-800 border border-gray-300 px-3 py-1.5 rounded-lg hover:bg-gray-50 transition-colors font-semibold text-xs';

// Secondary and destructive: outlined like Snooze, red so it never reads as the main action.
export const CANCEL_VA_BUTTON =
    'inline-flex items-center gap-1.5 text-xs font-semibold text-red-600 bg-white hover:bg-red-50 border border-red-200 rounded-lg px-3 py-1.5 transition-colors disabled:opacity-50 disabled:cursor-not-allowed';

export const MARK_DONE_BUTTON =
    'inline-flex items-center gap-1.5 text-xs font-semibold text-green-700 bg-green-50 hover:bg-green-100 border border-green-200 rounded-lg px-3 py-1.5 transition-colors disabled:opacity-50 disabled:cursor-not-allowed';
